// extracted by mini-css-extract-plugin
export default {"container":"MeetTheTeam-module--container--ziLlu","subtitle":"MeetTheTeam-module--subtitle--lHXIq"};